export default {"src":"/_next/static/media/search.c354537b.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};